<template>
  <hr class="dashed-line">
</template>

<script>
  export default {
    name: 'DashedLine',
  };
</script>

<style lang="scss" scoped>
  .dashed-line {
    border: none;
    border-top: 2px dashed $dashedLineColor;
  }
</style>
